import React from 'react';
import './Home_Footer.scss';
import ticketyLogo from "../../assets/HelpNexis__2_-removebg-preview.png";
import ticketyFavicon from "../../assets/favicon.png";
import { useNavigate } from "react-router-dom";
 
function Home_Footer() {
    return (
        <footer className="footer2nd">
            <div className="footer-container">
                <p className="footer-text">
                    <span className="footer-brand">
                        <div className='logo'>
                            {/* <img src={ticketyFavicon} alt="tickety-favicon" /> */}
                            <img src={ticketyLogo} alt="tickety-logo" /> © 2025
                        </div>
 
                    </span>
                </p>
                <p className="footer-text">
                    Developed by <a href='https://qitsolution.co.in/' target="_blank" rel="noopener noreferrer">Quantum IT Solution</a>
                </p>
            </div>
        </footer>
    );
}
 
export default Home_Footer;